import * as Common from '@/tenant/common';

export class TaxCode extends Common.MasterBase{
  constructor(){
    super('TaxCode');
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public code: string = '';
  public name: string = '';
  public taxRate: number = 0;
  public taxType: TaxTypes = TaxTypes.Without;
  public taxRound: RoundTypes = RoundTypes.RoundMidpoint;
  public taxMark: string = '';
  public mappingCode: string = '';
  
  public copy():any {
    const temp = super.copy() as TaxCode;
    temp.code = null;    
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export enum TaxTypes {
  None = 0,
  Without = 1,
  Included = 2,
  NoTax = 3,
}

export enum RoundTypes {
  RoundMidpoint = 0,
  RoundDown = 1,
  RoundUp = 2,
}

export class TaxCodeQuery extends Common.LoadQuery {
  constructor(){
    super('TaxCodeQuery',TaxCode);
    this.sort = 'code';
  }

  public code: string = '';
  public name: string = '';
  public taxType: TaxTypes = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}